import React, { forwardRef, LiHTMLAttributes } from 'react';
import { css } from '@emotion/react';
import {
  pagination_item_css,
  pagination_button_css,
  pagination_button_default_style,
  pagination_button_disabled_style,
  pagination_button_selected_style,
  pagination_button_selected_disabled_style,
} from './styles';
import { useProviderConfig } from '../provider';

export interface PaginationItemProps extends Omit<LiHTMLAttributes<HTMLLIElement>, 'onClick'> {
  label?: string | number;
  disabled?: boolean;
  selected?: boolean;
  /** @default false */
  isNumberOutOfRange?: boolean;
  onClick?: () => void;
}

export const PaginationItem = forwardRef<HTMLLIElement, PaginationItemProps>(
  ({ label, disabled, selected, isNumberOutOfRange = false, onClick, ...props }, ref) => {
    const { locale } = useProviderConfig();
    const ariaLabel =
      locale?.lang === 'en-US' ? `${locale?.accessibility.page} ${label}` : `${label} ${locale?.accessibility.page}`;
    const status_style = {
      ...pagination_button_default_style,
      ...(disabled && pagination_button_disabled_style),
      ...(selected && pagination_button_selected_style),
      ...(selected && disabled && pagination_button_selected_disabled_style),
    };

    return (
      <li css={pagination_item_css} ref={ref} {...props}>
        {isNumberOutOfRange ? (
          <div
            css={[
              pagination_button_css,
              css`
                cursor: default;
                ${disabled && pagination_button_disabled_style}
              `,
            ]}
          >
            ...
          </div>
        ) : (
          <button
            type='button'
            disabled={disabled}
            aria-label={ariaLabel}
            css={[
              pagination_button_css,
              status_style,
              css`
                cursor: ${disabled ? 'default' : 'pointer'};
              `,
            ]}
            onClick={onClick}
          >
            {label}
          </button>
        )}
      </li>
    );
  },
);
